/**
 * @generated SignedSource<<f79d60afc1c48b3cc17462fe9e897d20>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ActivitySortBy = "COMPLETED_AT_ASC" | "COMPLETED_AT_DESC" | "CREATED_AT_ASC" | "CREATED_AT_DESC" | "DATE_ASC" | "DATE_DESC" | "%future added value";
export type ActivityType = "CLIENT_FORM" | "MEAL_LOGGING" | "NUTRITION_TARGET" | "PROGRAM_COMPONENT" | "%future added value";
export type CoachActivityRouteQuery$variables = {
  activityTypes: ReadonlyArray<ActivityType>;
  archived: boolean;
  orderBy: ActivitySortBy;
};
export type CoachActivityRouteQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CoachActivity_root">;
};
export type CoachActivityRouteQuery = {
  response: CoachActivityRouteQuery$data;
  variables: CoachActivityRouteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "activityTypes"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "archived"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v3 = {
  "kind": "Variable",
  "name": "coachArchived",
  "variableName": "archived"
},
v4 = {
  "kind": "Literal",
  "name": "withAnswersOnly",
  "value": true
},
v5 = {
  "kind": "Literal",
  "name": "withClientForms",
  "value": true
},
v6 = {
  "kind": "Literal",
  "name": "withMealLogging",
  "value": true
},
v7 = [
  {
    "kind": "Variable",
    "name": "activityTypes",
    "variableName": "activityTypes"
  },
  (v3/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 5
  },
  {
    "kind": "Variable",
    "name": "orderBy",
    "variableName": "orderBy"
  },
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v10 = [
  {
    "kind": "Literal",
    "name": "format",
    "value": "fromNow"
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "photoURL",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CoachActivityRouteQuery",
    "selections": [
      {
        "args": (v7/*: any*/),
        "kind": "FragmentSpread",
        "name": "CoachActivity_root"
      }
    ],
    "type": "Root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CoachActivityRouteQuery",
    "selections": [
      {
        "alias": "allActivities",
        "args": [
          (v3/*: any*/),
          {
            "kind": "Literal",
            "name": "first",
            "value": 0
          },
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "concreteType": "ActivityConnection",
        "kind": "LinkedField",
        "name": "activitiesConn",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "activities",
        "args": (v7/*: any*/),
        "concreteType": "ActivityConnection",
        "kind": "LinkedField",
        "name": "activitiesConn",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ActivityEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Activity",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "raw",
                        "value": true
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "date",
                    "storageKey": "date(raw:true)"
                  },
                  {
                    "alias": "dateFormatted",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "format",
                        "value": "ddd, MMM DD"
                      },
                      {
                        "kind": "Literal",
                        "name": "utc",
                        "value": true
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "date",
                    "storageKey": "date(format:\"ddd, MMM DD\",utc:true)"
                  },
                  {
                    "alias": null,
                    "args": (v10/*: any*/),
                    "kind": "ScalarField",
                    "name": "completedAt",
                    "storageKey": "completedAt(format:\"fromNow\")"
                  },
                  {
                    "alias": null,
                    "args": (v10/*: any*/),
                    "kind": "ScalarField",
                    "name": "submittedAt",
                    "storageKey": "submittedAt(format:\"fromNow\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "answers",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "edited",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startWorkout",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endWorkout",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Enrollment",
                    "kind": "LinkedField",
                    "name": "enrollment",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Program",
                        "kind": "LinkedField",
                        "name": "program",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "client",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      (v14/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "username",
                        "storageKey": null
                      },
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Component",
                    "kind": "LinkedField",
                    "name": "component",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      (v12/*: any*/),
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClientMetric",
                    "kind": "LinkedField",
                    "name": "metrics",
                    "plural": true,
                    "selections": [
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "formattedValue",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "value",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "url",
                                "storageKey": null
                              },
                              (v11/*: any*/),
                              (v9/*: any*/)
                            ],
                            "type": "CheckinAnswerFileValue",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ActivityFeedback",
                    "kind": "LinkedField",
                    "name": "feedbacks",
                    "plural": true,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "author",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "role",
                            "storageKey": null
                          },
                          (v13/*: any*/),
                          (v14/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v16/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "read",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v10/*: any*/),
                        "kind": "ScalarField",
                        "name": "createdAt",
                        "storageKey": "createdAt(format:\"fromNow\")"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WorkoutExerciseResult",
                    "kind": "LinkedField",
                    "name": "workoutExerciseResults",
                    "plural": true,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "value",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClientForm",
                    "kind": "LinkedField",
                    "name": "clientForm",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "coachArchived",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "coachReadAnswers",
                    "storageKey": null
                  },
                  (v16/*: any*/),
                  (v15/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "activities",
        "args": (v7/*: any*/),
        "filters": [],
        "handle": "connection",
        "key": "CoachActivity_activities",
        "kind": "LinkedHandle",
        "name": "activitiesConn"
      }
    ]
  },
  "params": {
    "cacheID": "c934318acaf1125aed87645b131f1c7f",
    "id": null,
    "metadata": {},
    "name": "CoachActivityRouteQuery",
    "operationKind": "query",
    "text": "query CoachActivityRouteQuery(\n  $archived: Boolean!\n  $orderBy: ActivitySortBy!\n  $activityTypes: [ActivityType!]!\n) {\n  ...CoachActivity_root_3HN72o\n}\n\nfragment ActivityResponseCard_activity on Activity {\n  id\n  type\n  date(raw: true)\n  dateFormatted: date(utc: true, format: \"ddd, MMM DD\")\n  completedAt(format: \"fromNow\")\n  submittedAt(format: \"fromNow\")\n  answers\n  edited\n  startWorkout\n  endWorkout\n  enrollment {\n    program {\n      name\n      slug\n      id\n    }\n    id\n  }\n  client {\n    displayName\n    photoURL\n    username\n    id\n  }\n  component {\n    type\n    title\n    slug\n    id\n  }\n  metrics {\n    id\n    type\n    name\n    formattedValue\n    value {\n      __typename\n      ... on CheckinAnswerFileValue {\n        url\n        name\n        type\n      }\n    }\n  }\n  feedbacks {\n    id\n    ...ActivityResponseItem_feedback\n  }\n  workoutExerciseResults {\n    ...ActivityWorkoutResponse_workoutExerciseResult\n    id\n  }\n  clientForm {\n    slug\n    id\n  }\n  coachArchived\n  coachReadAnswers\n  ...FeedbackForm_activity\n  ...ActivityResponseMealsList_activity\n}\n\nfragment ActivityResponseItem_feedback on ActivityFeedback {\n  id\n  author {\n    id\n    role\n    displayName\n    photoURL\n  }\n  content\n  read\n  createdAt(format: \"fromNow\")\n}\n\nfragment ActivityResponseMealsList_activity on Activity {\n  content\n}\n\nfragment ActivityWorkoutResponse_workoutExerciseResult on WorkoutExerciseResult {\n  id\n  value\n}\n\nfragment CoachActivity_root_3HN72o on Root {\n  allActivities: activitiesConn(first: 0, withAnswersOnly: true, withMealLogging: true, withClientForms: true, coachArchived: $archived) {\n    totalCount\n  }\n  activities: activitiesConn(first: 5, withAnswersOnly: true, withMealLogging: true, withClientForms: true, coachArchived: $archived, orderBy: $orderBy, activityTypes: $activityTypes) {\n    edges {\n      node {\n        ...ActivityResponseCard_activity\n        id\n        coachArchived\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment FeedbackForm_activity on Activity {\n  id\n  client {\n    displayName\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "2ec6f510a832724ed2b78f82c56dcb25";

export default node;
